var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.341 6.84532C11.8095 6.57072 12.3897 6.57072 12.8582 6.84532L21.4917 11.9064C22.4803 12.4859 22.4803 13.9149 21.4917 14.4944L12.8582 19.5555C12.3897 19.8301 11.8095 19.8301 11.341 19.5555L2.70749 14.4944C1.71893 13.9149 1.71893 12.4859 2.70749 11.9064L11.341 6.84532Z",
    fill: "#E8EBAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.341 3.64317C11.8095 3.36857 12.3897 3.36857 12.8582 3.64317L21.4917 8.7042C22.4803 9.2837 22.4803 10.7128 21.4917 11.2923L12.8582 16.3533C12.3897 16.6279 11.8095 16.6279 11.341 16.3533L2.70749 11.2923C1.71893 10.7128 1.71893 9.2837 2.70749 8.7042L11.341 3.64317Z",
    fill: "#D5D88F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.341 0.444685C11.8095 0.170081 12.3897 0.17008 12.8582 0.444684L21.4917 5.50572C22.4803 6.08522 22.4803 7.51431 21.4917 8.09381L12.8582 13.1548C12.3897 13.4294 11.8095 13.4294 11.341 13.1548L2.70749 8.09381C1.71893 7.51431 1.71893 6.08522 2.70749 5.50572L11.341 0.444685Z",
    fill: "#C4C678"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWb);
export default __webpack_public_path__ + "static/media/wb.01f4d442bae43b471698b211e2ec8b2c.svg";
export { ForwardRef as ReactComponent };